import React, { useState, useEffect, useRef } from 'react';
import '../styles/pages/dataSets.scss';
import Add from "../assets/icons/add"
import Close from "../assets/icons/close"
import Cookies from 'js-cookie';
import apiService from '../services/apiService'
import { Toast } from 'primereact/toast';
//import authApiService from '../services/authApiService';

import axios from "axios"

import { useNavigate } from "react-router-dom";

const DatasetsModal = props => {
    const navigate = useNavigate(); 
    const {getDataSet}=props
    const userId = Cookies.get('userId')
    const [checkboxData, setCheckboxData] = useState(false);
    const [datasetName, setDatasetName] = useState("")

    const toast = useRef(null);

    const getDataUserId    = JSON.parse(sessionStorage.getItem('userid'));
    const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));


    const groupIds = JSON.parse(sessionStorage.getItem('usergroups'));

    const onCreateDataset = async () => {
        let formData = new FormData();
        formData.append("name", datasetName);
        formData.append("ownerId", userId);
        formData.append("groupId", groupIds);
        formData.append("public", checkboxData);

        const headers = {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${getDataUserToken}`,
        };

        axios.post( `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/dataset`, formData, {
        headers,
        }).then((response) => {
            console.log(response);
            // getDataSet()
            console.log("res from post dataset",response)
            console.log(response.data.id)

            // toast.current.show({ severity: 'success', summary: response.data.message, life: 3000 });


            const dataset_id = response.data.id
            const dataset_name = response.data.name

            const path = "dataset_details" ; 
            navigate(path,{
                state:{
                    id:dataset_id,
                    name:dataset_name
                }
            });

        }).catch((error) => {
            // console.log(error);
            console.error("err from post dataset",error)
            toast.current.show({ severity: 'error', summary: "Dataset not created", life: 3000 });
        });

        // await apiService.CreateDataset(formData).then((response) => {
        //     getDataSet()
        //     console.log("res from post dataset",response)
        //     console.log(response.data.id)

        //     // toast.current.show({ severity: 'success', summary: response.data.message, life: 3000 });

            
        //     const dataset_id = response.data.id
        //     const dataset_name = response.data.name

        //     const path = "manage_sample/new_sample/upload-csv" ; 
        //     navigate(path,{
        //         state:{
        //             id:dataset_id,
        //             name:dataset_name
        //         }
        //     });

        // }).catch((err) => {
        //     console.log("err from post dataset",err)
        //     toast.current.show({ severity: 'error', summary: "Dataset not created", life: 3000 });
        // })
    }

    // const getUserData = async () =>{
    //    await authApiService.GetUser(userId).then((res) => {
    //         console.log(" file: index.js:59 ~ useEffect ~ res:", res)
    //     })
    // }

    // useEffect(()=>{
    //   getUserData()
    // },[])

    const onCheckboxChange = () => {
        var checkBox = document.getElementById("publicCheck");
        if (checkBox.checked) {
            setCheckboxData(true)
        } else {
            setCheckboxData(false)
        }
    }

    const onTextChange = (e) => {
        setDatasetName(e.target.value)
    }

    return (
        <div className="modal fade" id="myModal">
            <div className="modal-dialog  modal-dialog-centered">
                <div className="modal-content  modal-sm">
                    <div className="modal-header">
                        <h5 className="modal-title">Create new dataset</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div className="modal-body">
                        <div>Dataset name</div>
                        <input type="text" class="form-control" id="name" placeholder="Type here..." onChange={(e) => onTextChange(e)} />
                        <br />
                        <div>
                            <input type="checkbox" id="publicCheck" checked={checkboxData} onChange={onCheckboxChange} />
                            <label for="public"> Public dataset</label><br />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className="closeBtn" data-bs-dismiss="modal">
                            <Close color={"#f58220"} />
                            <a>Close</a>
                        </button>
                        <button className="createBtn" onClick={onCreateDataset} data-bs-dismiss="modal">
                            <Add color={"white"} />
                            <a style={{ paddingLeft: "0.3rem" }} >Create</a>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DatasetsModal;
